import type { components } from "../../../api/generated";
import type {
  AuthLegacyJumpUrlMutation,
  AuthLegacyJumpUrlPayload,
  AuthPasswordResetMutation,
  AuthSession,
  AuthUser,
} from "../types";

export type AuthLoginRequest = components["schemas"]["AuthLoginRequest"];
export type AuthLegacySingleLoginRequest = components["schemas"]["AuthLegacySingleLoginRequest"];
export type AuthLegacyJumpUrlRequest = components["schemas"]["AuthLegacyJumpUrlRequest"];
export type AuthLegacyJumpUrlSuccessResponse = components["schemas"]["AuthLegacyJumpUrlSuccessResponse"];
export type AuthRegisterRequest = components["schemas"]["AuthRegisterRequest"];
export type AuthPasswordResetRequest = components["schemas"]["AdminResetPasswordRequest"];
export type AuthPasswordResetSuccessResponse = components["schemas"]["AdminResetPasswordSuccessResponse"];
export type AuthSessionSuccessResponse = components["schemas"]["AuthSessionSuccessResponse"];
export type AuthUserSuccessResponse = components["schemas"]["AuthUserSuccessResponse"];
export type WechatBindRequest = components["schemas"]["WechatBindRequest"];
export type WechatLoginRequest = components["schemas"]["WechatLoginRequest"];

type AuthSessionPayload = components["schemas"]["AuthSessionPayload"];
type AuthUserProfile = components["schemas"]["AuthUserProfile"];
type AuthLegacyJumpUrlRawPayload = components["schemas"]["AuthLegacyJumpUrlPayload"];

/** 映射管理员重置密码载荷。 */
export function mapAuthPasswordResetPayload(payload: AuthPasswordResetMutation): AuthPasswordResetRequest {
  return {
    password: payload.password,
  };
}

/** 映射旧系统单点号登录请求。 */
export function mapAuthLegacySingleLoginPayload(singleLoginNo: string): AuthLegacySingleLoginRequest {
  return {
    single_login_no: singleLoginNo.trim(),
  };
}

/** 映射旧系统跳转地址请求。 */
export function mapAuthLegacyJumpUrlPayload(payload: AuthLegacyJumpUrlMutation): AuthLegacyJumpUrlRequest {
  return {
    target_url: payload.targetUrl.trim(),
  };
}

/** 映射后端会话载荷为前端认证会话。 */
export function mapAuthSession(raw: AuthSessionPayload): AuthSession {
  return {
    accessToken: raw.access_token,
    tokenType: raw.token_type,
    expiresIn: raw.expires_in,
    user: mapAuthUser(raw.user),
  };
}

/** 映射旧系统跳转地址响应载荷。 */
export function mapAuthLegacyJumpUrl(raw: AuthLegacyJumpUrlRawPayload): AuthLegacyJumpUrlPayload {
  return {
    jumpUrl: raw.jump_url,
  };
}

/** 映射后端用户资料为前端认证用户。 */
export function mapAuthUser(raw: AuthUserProfile): AuthUser {
  return {
    id: raw.id,
    username: raw.username,
    displayName: raw.display_name,
    realname: raw.realname ?? null,
    nickname: raw.nickname ?? null,
    email: raw.email ?? null,
    phone: raw.phone ?? null,
    roles: raw.roles ?? [],
    scopes: raw.scopes ?? [],
    permissions: raw.permissions ?? [],
    isSuperuser: raw.is_superuser,
    isStaff: raw.is_staff,
    wxOpenid: raw.wx_openid ?? null,
    wxUnionid: raw.wx_unionid ?? null,
  };
}
